import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9c8ff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mxa-nologin-main" }
const _hoisted_2 = {
  class: "mxa-nologin-main-explanation",
  "data-test": "desc"
}
const _hoisted_3 = { class: "mxa-nologin-main-inputgroup" }
const _hoisted_4 = { class: "mxa-nologin-main-input" }

import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import BaseInput from '@/components/common/input/BaseInput.vue'
import BaseButton from '@/components/common/button/BaseButton.vue'
import ErrorMessage from '@/components/common/screen/ErrorMessage.vue'
import * as log from '@/model/util/log/Logger'
import { useResetPassword, preauth, useErrorMsg } from '@/model/components/users/userResetPassword'
import NologinTitle from '@/components/main/nologin/NologinTitle.vue'
import RegisterStepbar from '../../components/main/nologin/RegisterStepbar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

log.trace('Reset password setup start.')

// 状態
const store = useStore()
const router = useRouter()
const state = useResetPassword()
const errorState = useErrorMsg()

// ボタン押下処理
const onclick = () => {
  log.trace(`ResetPassword onClick start.`)
  // API実施してワンタイムパスワード送信画面に遷移
  preauth(state, store, router, errorState)
  log.trace(`ResetPassword onClick end.`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RegisterStepbar, {
      active: 1,
      type: "1"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NologinTitle, {
        isEntry: true,
        type: "1"
      }),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('body.reset.message')), 1),
      _createElementVNode("form", {
        action: "",
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(BaseInput, {
              type: "email",
              placeholder: _ctx.$t('body.reset.username.placeholder'),
              maxlength: 254,
              "init-focus": true,
              "data-test": "email",
              modelValue: _unref(store).state.screen.top.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).state.screen.top.username) = $event)),
              onInputEnter: onclick
            }, null, 8, ["placeholder", "modelValue"])
          ])
        ]),
        _createVNode(ErrorMessage, { error: _unref(errorState) }, null, 8, ["error"]),
        _createVNode(BaseButton, {
          loading: _unref(state).loading,
          isDisabled: _unref(state).loading,
          label: _ctx.$t('body.reset.button.next.title'),
          styles: "mxa-nologin-main-button",
          onButtonClick: onclick
        }, null, 8, ["loading", "isDisabled", "label"])
      ], 32)
    ])
  ], 64))
}
}

})